module.exports = __webpack_public_path__ + "img/home-page-final-hopefully.83ec7ae.png";